<div class="max-w-xl mx-auto p-6 bg-white shadow rounded-xl space-y-8">
       <h2 class="text-2xl font-bold text-center text-primary">Générer une URL sécurisée</h2>

       <!-- Formulaire NOTE -->
       <form (submit)="generateNoteUrl(); $event.preventDefault()" class="space-y-4">
              <h3 class="text-lg font-semibold text-gray-700">Formulaire pour <code>/note</code></h3>
              <span>client_shop_name</span>
              <input type="text" [(ngModel)]="noteDenomination" name="noteDenomination" placeholder="Dénomination"
                     class="w-full p-2 border rounded" required />
              <span>code</span>
              <input type="text" [(ngModel)]="noteCode" name="noteCode" placeholder="Code"
                     class="w-full p-2 border rounded" required />
              <span>note_id</span>
              <input type="number" [(ngModel)]="noteId" name="noteId" placeholder="ID" class="w-full p-2 border rounded"
                     required />
              <span>table_number</span>
              <input type="number" [(ngModel)]="noteTableNumber" name="noteTableNumber" placeholder="Numéro de table"
                     class="w-full p-2 border rounded" required />

              <button type="submit" class="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700">
                     Générer URL Note
              </button>
       </form>

       <!-- Formulaire QRCODE -->
       <form (submit)="generateQRCodeUrl(); $event.preventDefault()" class="space-y-4">
              <h3 class="text-lg font-semibold text-gray-700">Formulaire pour <code>/qrcode</code></h3>
              <span>client_code</span>
              <input type="number" [(ngModel)]="qrUserId" name="qrUserId" placeholder="User ID"
                     class="w-full p-2 border rounded" required />
              <span>code</span>
              <input type="text" [(ngModel)]="qrCode" name="qrCode" placeholder="Code" class="w-full p-2 border rounded"
                     required />
              <span>table_number</span>
              <input type="number" [(ngModel)]="qrTableId" name="qrTableId" placeholder="Table ID"
                     class="w-full p-2 border rounded" required />
              <button type="submit" class="w-full bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700">
                     Générer URL QRCode
              </button>
       </form>

       <!-- Affichage de l'URL générée -->
       <div *ngIf="generatedUrl" class="bg-gray-100 p-4 rounded text-sm border border-gray-300">
              <p class="font-medium text-gray-800 mb-1">URL générée :</p>
              <input type="text" [value]="generatedUrl" readonly
                     class="w-full bg-white text-blue-800 border border-gray-200 rounded px-2 py-1 font-mono cursor-text select-all"
                     (click)="copyToClipboard(generatedUrl)" />
              <p class="text-xs text-gray-500 mt-1">Clique sur l’URL pour la copier.</p>
       </div>


       <!-- Chargement -->
       <div *ngIf="isLoading" class="text-center text-gray-500">Génération en cours...</div>

       <!-- Erreur -->
       <div *ngIf="error" class="text-red-600 text-center font-semibold">{{ error }}</div>
</div>